import { Editor } from "@tinymce/tinymce-react";
import React from "react";
import { ReactNode, useState } from "react"
import { Button, Form, FormCheck, FormControl, FormSelect } from "react-bootstrap"
import { FileEarmark } from "react-bootstrap-icons";
import { config_editor, serverURL } from "../Funciones";
export type FormContextType = {
	datos: FormData,
	change: Function,
	readOnly?: boolean | undefined
}
export const FormContext = React.createContext<FormContextType>(null!);
export const Formulario: React.FC<{ submit: Function, change: Function, datos: FormData, children: ReactNode, readOnly?: boolean | undefined }> = ({ submit, change, datos, children, readOnly }) => {

	const [validado, setValidado] = useState(false);
	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

		let form = event.currentTarget;
		form.querySelectorAll("[type='submit']").forEach((el) => {
			el.setAttribute("disabled", "")
		})

		event.stopPropagation()
		event.preventDefault()

		if (form.checkValidity() === false) {
		}
		else {
			await submit(event);
			setTimeout(() => {
				setValidado(false)
			}, 3000)
		}
		form.querySelectorAll("[type='submit']").forEach((el) => {
			el.removeAttribute("disabled")
		})
		setValidado(true);
	}

	return <FormContext.Provider value={{ datos, change, readOnly }}>
		<Form autoComplete="off" noValidate validated={validado} onSubmit={(event) => { handleSubmit(event) }}>
			{children}
		</Form>
	</FormContext.Provider>
}
export enum TipoCampo {
	AreaTexto,
	Texto,
	Password,
	Numero,
	Email,
	Fecha,
	Select,
	Radio,
	Checkbox,
	Archivo,
	Editor
}
export const Campo: React.FC<{ tipo: TipoCampo, nombre: string, radioValue?: string, label?: string, required?: boolean | undefined, disabled?: boolean | undefined, children?: ReactNode, readOnly?: boolean | undefined, rows?: number, autofocus?: boolean | undefined }> = ({ tipo, nombre, radioValue, label, required, disabled, children, readOnly, rows, autofocus }) => {

	const context = React.useContext(FormContext);
	const [valorInicial, setValorInicial] = useState<string | null>(null)

	const handleChange = (ev: any) => {
		context.change(ev);
	}

	let valor = context.datos.get(nombre);
	if (tipo === TipoCampo.Archivo && valorInicial === null && valor && !(valor instanceof File)) {
		setValorInicial(valor)
	}

	switch (tipo) {
		case TipoCampo.AreaTexto:
			return <FormControl autoFocus={autofocus} autoComplete="off" type="text" as={"textarea"} disabled={disabled} required={required} readOnly={context.readOnly || readOnly} plaintext={context.readOnly || readOnly} name={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} style={{ minHeight: rows ? (30 * rows) : 100 }} size="sm" onChange={(e) => handleChange(e)} />
		case TipoCampo.Texto:
			return <FormControl autoFocus={autofocus} autoComplete="off" type="text" disabled={disabled} required={required} readOnly={context.readOnly || readOnly} plaintext={context.readOnly || readOnly} name={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} size="sm" onChange={(e) => handleChange(e)} />
		case TipoCampo.Editor:
			return <Editor init={{ ...config_editor, height: 400 }} disabled={disabled || context.readOnly || readOnly} textareaName={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} onChange={(e) => { handleChange(e); }} onEditorChange={(content, editor) => { editor.fire("change"); }} onUndo={(ev, editor) => editor.fire("change")} onRedo={(ev, editor) => editor.fire("change")}/>
		case TipoCampo.Password:
			return <FormControl autoFocus={autofocus} autoComplete="off" type="password" disabled={disabled} required={required} readOnly={context.readOnly || readOnly} plaintext={context.readOnly || readOnly} name={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} size="sm" onChange={(e) => handleChange(e)} />
		case TipoCampo.Numero:
			return <FormControl autoFocus={autofocus} autoComplete="off" type="number" disabled={disabled} required={required} readOnly={context.readOnly || readOnly} plaintext={context.readOnly || readOnly} name={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} size="sm" onChange={(e) => handleChange(e)} />
		case TipoCampo.Email:
			return <FormControl autoFocus={autofocus} autoComplete="off" type="email" disabled={disabled} required={required} readOnly={context.readOnly || readOnly} plaintext={context.readOnly || readOnly} name={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} size="sm" onChange={(e) => handleChange(e)} />
		case TipoCampo.Fecha:
			return <FormControl autoFocus={autofocus} autoComplete="off" type="date" disabled={disabled} required={required} readOnly={context.readOnly || readOnly} plaintext={context.readOnly || readOnly} name={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} size="sm" onChange={(e) => handleChange(e)} />
		case TipoCampo.Select:
			if (context.readOnly || readOnly) {
				return <>{valor ? valor.toString() : ""}</>
			}
			else {
				return <FormSelect disabled={disabled} required={required} name={nombre} id={"form_" + nombre} value={valor ? valor.toString() : ""} size="sm" onChange={(e) => handleChange(e)} >
					{children}
				</FormSelect>
			}
		case TipoCampo.Checkbox:
			return <FormCheck type="switch" disabled={disabled || context.readOnly || readOnly} name={nombre} id={"form_" + nombre} checked={valor === "1"} label={label} onChange={(e) => {
				if (e.target.checked)
					e.target.value = "1";
				else
					e.target.value = "0"
				handleChange(e);
			}} />
		case TipoCampo.Radio:
			return <FormCheck type="radio" disabled={disabled || context.readOnly || readOnly} name={nombre} value={radioValue} id={"form_" + nombre + "_" + radioValue} checked={valor === radioValue} label={label} onChange={(e) => { handleChange(e); }} />
		case TipoCampo.Archivo:
			return <>
				{valorInicial && <div><Button variant="secondary" target="_blank" href={serverURL + valorInicial} size="sm" className="mb-1"><FileEarmark /> Ver archivo actual</Button></div>}
				{!(context.readOnly || readOnly) && <FormControl type="file" size="sm" disabled={disabled} required={required} name={nombre} id={"form_" + nombre} onChange={(e) => handleChange(e)} />}
			</>

		default:
			break;
	}

	return <>{nombre}{children}</>
}